<script lang="ts" setup>
const props = defineProps({
  setId: {
    type: String,
    required: true,
  },
});

const { getCollectibleSet, getCheapestCollectibleInSet } =
  useCollectiblesController();
const route = useRoute();
const { getMerchantAttributes } = useLuxuryDesign();

const { data: set, status } = await useAsyncData(
  "getCollectibleSet",
  async () => {
    return await getCollectibleSet(
      route.params.merchant as string,
      props.setId
    );
  },
  {
    default() {
      return null;
    },
    server: false,
    lazy: true,
  }
);

const { data: cheapestCollectible, pending: isLoadingCheapest } =
  await useAsyncData(
    `getCheapestCollectibleInSet-${props.setId}`,
    async () => {
      return await getCheapestCollectibleInSet(
        route.params.merchant as string,
        props.setId,
        true
      );
    },
    {
      default: () => null,
      server: false,
      lazy: true,
    }
  );

const cardAttributes = computed(() =>
  getMerchantAttributes(
    set.value?.merchantId || (route.params.merchant as string)
  )
);
</script>

<template>
  <div
    v-if="status === 'success' && set"
    v-bind="cardAttributes"
    class="border-2 border-primary-900 rounded-lg mx-auto merchant-card">
    <div class="lg:grid grid-cols-3 overflow-hidden">
      <CardDetailImage
        :merchantId="set.merchantId"
        :rarity="set.rarity"
        :image-id="set.imageId"
        :properties="set.defaultProperties" />
      <div
        class="lg:col-start-2 lg:row-span-3 lg:col-span-2 flex flex-col border-t border-l-0 lg:border-l lg:border-t-0 border-primary-900">
        <CardDetailTitle
          :id="set.id"
          :translation-id="set.translationId"
          :merchantId="set.merchantId"
          :categoryId="set.categoryId"
          :number="0"
          :total="0" />
        <div v-if="set.supply" class="border-b-2 border-primary-900 px-7 py-5">
          <h1 class="text-secondary-200 font-bold">
            {{ $t("main.cardCollectible.totalSupply", { supply: set.supply }) }}
          </h1>
        </div>
        <CardDetailDescription :translationId="set.translationId" />
        <CardDetailProperties
          v-if="set.merchantId !== 'proof-of-luxe'"
          :rarity="set.rarity"
          :image-id="set.imageId"
          :properties="set.defaultProperties"
          :merchant-id="set.merchantId" />
        <div v-if="isLoadingCheapest" class="p-4">
          <LoaderBuyButtonsSkeleton />
        </div>
        <div
          v-else-if="!isLoadingCheapest && cheapestCollectible"
          class="flex flex-wrap gap-4 pl-7 item-detail__actions">
          <CardDetailBuyButton
            :collectible="cheapestCollectible ?? undefined"
            :buy-cheapest-in-set="true" />
          <CardDetailOfferMakeButton
            :disabled="cheapestCollectible === null"
            :collectible="
              cheapestCollectible ? cheapestCollectible : undefined
            " />
        </div>
      </div>
    </div>
  </div>
  <LoaderSetDetailSkeleton v-else />
</template>
